import React, { type FunctionComponent } from 'react';

import { Skeleton as TailwindSkeleton } from '@/core/tamagoshiTailwind/components/Skeleton/Skeleton';
import { twMerge } from '@/domains/core/tamagoshiTailwind/util/twMerge';

interface Props {
  className?: string;
  withAddToCartButton?: boolean;
}

export const Skeleton: FunctionComponent<Props> = React.memo(
  ({ className, withAddToCartButton = true }) => {
    return (
      <div
        className={twMerge('relative w-full py-0', className)}
        data-testid="products-skeleton"
      >
        <TailwindSkeleton.Group
          className="mx-0 mb-0 mt-m inline-flex flex-row desktop:mt-s
            desktop:grid desktop:grid-cols-3 desktop:gap-s"
        >
          {[1, 2, 3, 4, 5, 6].map((key) => (
            <TailwindSkeleton.Block
              width="152px"
              height="194px"
              key={`product-${key}`}
            />
          ))}
        </TailwindSkeleton.Group>

        {withAddToCartButton && (
          <div
            className="fixed bottom-0 left-0 mt-s hidden w-full
              bg-foundation-inverted desktop:relative desktop:block"
          >
            <TailwindSkeleton.Block height="40px" />
          </div>
        )}
      </div>
    );
  },
);

Skeleton.displayName = 'Skeleton';
